<template>
  <v-container fluid>
    <!-- Private Home -->
    <v-row>
      <!-- Main -->
      <v-col cols="9">
        <!-- User Profile -->
        <v-row>
          <v-col>
            <div class="display-1 font-weight-bold">
            User Profile
            <!-- <hr style="border-color: primary;"/> -->
            </div>
            <v-row>
              <v-col md="8">
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.username"
                      label="Username"
                      disabled
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.email"
                      label="Email"
                      disabled
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.first_name"
                      label="Firstname"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.last_name"
                      label="Lastname"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.company"
                      label="Company"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      v-model="user_profile.phone"
                      label="Phone number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-btn
                  color="grey"
                  :loading="loading"
                  @click.native="updateUserProfile"
                  block
                  class="mt-4"
                >
                    <v-icon left dark>mdi-check</v-icon>
                    Update Profile
                </v-btn>
              </v-col>
              <v-col md="4">
                <v-card color="elevation-4lightbg">
                  <v-card-title @click='showEditPasswordCard=!showEditPasswordCard' button>
                    Edit Password <v-icon left dark>mdi-chevron-double-right</v-icon>
                  </v-card-title>
                  <v-card-text v-if='showEditPasswordCard'>
                    <v-text-field
                      outlined
                      v-model="user_profile_chpwd.old_password"
                      :append-icon="showPassword_old ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword_old ? 'text' : 'password'"
                      @click:append="showPassword_old = !showPassword_old"
                      counter
                      autocomplete="current-password"
                      label="Current Password"
                      dense
                    ></v-text-field>
                    <v-text-field
                      outlined
                      v-model="user_profile_chpwd.new_password1"
                      :append-icon="showPassword_new1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword_new1 ? 'text' : 'password'"
                      @click:append="showPassword_new1 = !showPassword_new1"
                      counter
                      autocomplete="new-password"
                      label="New Password"
                      dense
                    ></v-text-field>
                    <v-text-field
                      outlined
                      v-model="user_profile_chpwd.new_password2"
                      :append-icon="showPassword_new2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword_new2 ? 'text' : 'password'"
                      @click:append="showPassword_new2 = !showPassword_new2"
                      counter
                      autocomplete="new-password"
                      label="New Password (again)"
                      dense
                    ></v-text-field>

                    <v-btn
                      color="grey"
                      :loading="loading"
                      :disabled="user_profile_chpwd.new_password1 != user_profile_chpwd.new_password2"
                      @click.native="updateUserPassword"
                      block
                      class="mt-4"
                      >
                        <v-icon left dark>mdi-check</v-icon>
                        Update Password
                    </v-btn>
                  </v-card-text>

                </v-card>
              </v-col>
            </v-row>
            <!-- <v-btn color="deep-primary" @click="renewUserPassword">Renew password</v-btn> {{new_password}} -->

          </v-col>
        </v-row>

        <!-- Subscriptions -->
        <v-row>
          <v-col>
            <div class="display-1 font-weight-bold">
            Subscriptions
            <v-btn small icon color="grey" class="mr-2" @click="reloadSub"><v-icon>mdi-cached</v-icon></v-btn>
            <v-btn small color="warning" @click="dialog_pricing = true">+ Add new</v-btn>
            <!-- <hr style="border-color: primary;"/> -->
            </div>

            <v-data-table
              ref="subscriptionstable"
              :headers="subscriptions_headers"
              :items="subscriptions"
              :options.sync="subscriptions_options"
              :server-items-length="subscriptions_total"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-options': subscriptions_rowsPerPageItems
              }"
              :loading="subscriptions_loading"
              class="elevation-4lightbg"
              item-key="id"
            >
              <!-- plan_amount -->
              <template v-slot:item.plan_amount="{ item }">
                {{item.plan_amount}},00 €/{{item.plan_interval[0]}}
              </template>

              <!-- plan_amount -->
              <template v-slot:item.patrowlhears_accounts[0].username="{ item }">
                {{item.patrowlhears_accounts[0].username}}
                <!-- <v-icon @click="viewPassword(item.patrowlhears_accounts[0].password)">mdi-shield-key</v-icon> -->
              </template>

              <!-- Status -->
              <template v-slot:item.status="{ item }">
                <v-chip
                  color="warning" class="text-center" small label
                  v-if="['active', 'trialing'].includes(item.status) && item.cancel_at != null"
                  >{{item.status}}</v-chip>
                <v-chip
                  color="success" class="text-center" small label
                  v-else-if='item.status == "active"'
                  >{{item.status}}</v-chip>
                <v-chip
                  color="warning" class="text-center" small label
                  v-else-if='item.status == "trialing"'
                  >{{item.status}}</v-chip>
                <v-chip
                  color="error" class="text-center" small label
                  v-else
                  >{{item.status}}</v-chip>
              </template>

              <!-- Started at -->
              <template v-slot:item.start_date="{ item }">
                <span :title="moment(item.start_date).format('YYYY-MM-DD, hh:mm:ss')">{{moment(item.start_date).format('YYYY-MM-DD')}}</span>
              </template>

              <!-- Trial ended at -->
              <template v-slot:item.cancel_at="{ item }">
                <span v-if='item.cancel_at' :title="moment(item.cancel_at).format('YYYY-MM-DD, hh:mm:ss')">{{moment(item.cancel_at).format('YYYY-MM-DD')}}</span>
              </template>

              <!-- Actions -->
              <template v-slot:item.action="{ item }">
                <v-icon
                  title="Show subscription details"
                  class="mdi mdi-page-next"
                  color="primary"
                  @click="showSubscriptionDetails(item.djstripe_id)"
                ></v-icon>
                <v-icon
                  title="Cancel subscription"
                  class="mdi mdi-close-circle"
                  color="grey"
                  v-if="['active', 'trialing'].includes(item.status) && item.cancel_at == null"
                  @click="cancelSubscription(item.id)"
                ></v-icon>
                <v-icon
                  title="Reactivate Subscription"
                  class="mdi mdi-chevron-right-circle"
                  color="green"
                  v-if="['active', 'trialing'].includes(item.status) && item.cancel_at != null"
                  @click="reactivateSubscription(item.id)"
                ></v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>

        <!-- Invoices -->
        <v-row>
          <v-col>
            <div class="display-1 font-weight-bold">
            Invoices
            <!-- <hr style="border-color: primary;"/> -->
            </div>

            <v-data-table
              ref="invoicestable"
              :headers="invoices_headers"
              :items="invoices"
              :options.sync="invoices_options"
              :server-items-length="invoices_total"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-options': invoices_rowsPerPageItems
              }"
              :loading="invoices_loading"
              class="elevation-4lightbg"
              item-key="id"
            >

            <!-- Amount -->
            <template v-slot:item.amount_paid="{ item }">
              {{item.amount_paid}}€
            </template>

            <!-- PDF -->
            <template v-slot:item.invoice_pdf="{ item }">
              <v-btn :href="item.invoice_pdf" small color="primary"><v-icon
                title="Download invoice as PDF file"
                class="mdi mdi-download"
                color="darkbg"
              ></v-icon>PDF</v-btn>
            </template>

            <!-- status -->
            <template v-slot:item.paid="{ item }">
              <v-chip
                v-if="item.paid == true"
                color="success" class="text-center" small label>paid</v-chip>
              <v-chip
                v-else
                color="error" class="text-center" small label>error</v-chip>
            </template>

            <!-- Created -->
            <template v-slot:item.created="{ item }">
              <span v-if='item.created' :title="moment(item.created).format('YYYY-MM-DD, hh:mm:ss')">{{moment(item.created).format('YYYY-MM-DD')}}</span>
            </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-col>

      <!-- News / side threads -->
      <v-col cols="3">
        <Timeline
          style="width: 300px;"
          class="elevation-2"
          id="patrowl_io"
          sourceType="profile"
          :options="{ tweetLimit: '3', chrome: 'nofooter noborders transparent', conversation: 'none'}"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor" dense>
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog_pricing" max-width="80%">
      <sec-pricing :user="this.user_profile" bgclass="darkbg" showtitle="false"></sec-pricing>
    </v-dialog>

    <v-dialog v-model="dialog_subscription_details" max-width="70%">
      <subscription-details :subscription_id="this.selected_subscription"></subscription-details>
    </v-dialog>

  </v-container>
</template>

<script>
import moment from 'moment';
import SecPricing from '@/components/pages/public/SecPricing.vue';
import SubscriptionDetails from '@/components/pages/private/SubscriptionDetails.vue';
import { Timeline } from 'vue-tweet-embed';


export default {
  name: "PrivateHome",
  components: {
    SecPricing,
    SubscriptionDetails,
    Timeline
  },
  data: () => ({
    loading: false,
    dialog_pricing: false,
    dialog_subscription_details: false,
    selected_subscription: '',
    user_profile: {
      username: '',
      email: '',
      last_login: '',
      first_name: '',
      last_name: '',
      company: '',
      phone: '',
    },
    user_profile_chpwd: {
      old_password: '',
      new_password1: '',
      new_password2: '',
    },
    showEditPasswordCard: false,
    showPassword: false,
    showPassword_old: false,
    showPassword_new1: false,
    showPassword_new2: false,
    rules: {
      password: [
        v => !!v || "Password is required",
        v => (v && v.length > 8) || "The password must be longer than 8 characters",
        v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
        v => /(?=.*\d)/.test(v) || 'Must have one number',
        v => /([!@$%])/.test(v) || 'Must have one special character [!@#$%]'
      ],
      email: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    },
    new_password: '',
    subscriptions: [],
    subscriptions_total: 0,
    subscriptions_loading: false,
    subscriptions_limit: 5,
    subscriptions_options: {},
    subscriptions_headers: [
      { text: 'Product', value: 'product_name' },
      // { text: 'Amount', value: 'plan_amount' },
      { text: 'Status', value: 'status' },
      { text: 'Started at', value: 'start_date' },
      { text: 'Trial end', value: 'trial_end' },
      { text: 'Cancel end', value: 'cancel_at' },
      { text: 'Username', value: 'patrowlhears_accounts[0].username' },
      { text: 'Actions', value: 'action', align: 'center', sortable: false },
    ],
    subscriptions_rowsPerPageItems: [5, 10, 20, 50, 100],
    invoices: [],
    invoices_total: 0,
    invoices_loading: false,
    invoices_limit: 5,
    invoices_options: {},
    invoices_headers: [
      { text: 'Number', value: 'number' },
      { text: 'Date', value: 'created' },
      { text: 'Product', value: 'product_name' },
      { text: 'Amount', value: 'amount_paid' },
      { text: 'Status', value: 'paid' },
      { text: 'Download', value: 'invoice_pdf', sortable: false },
    ],
    invoices_rowsPerPageItems: [5, 10, 20, 50, 100],
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  mounted() {
    this.getUserProfile();
    this.subscriptions_options.page = 1;  // Force watch
    this.invoices_options.page = 1;
  },
  watch: {
    subscriptions_options: {
      handler() {
        this.getSubscriptionsFromAPI();
      },
      deep: true
    },
    invoices_options: {
      handler() {
        this.getInvoicesFromAPI();
      },
      deep: true
    },
  },
  methods: {
    reloadSub(){
      this.subscriptions_options.page = 1
      this.getSubscriptionsFromAPI();
      this.invoices_options.page = 1;
      this.getInvoicesFromAPI();
    },
    viewPassword(p){
      this.snack = true;
      this.snackColor = 'error';
      this.snackText = 'Coucou: '+p ;
    },
    getUserProfile(){
      this.$api.get('/api/auth/users/profile').then(res => {
        if (res && res.status === 200) {
          this.user_profile = res.data.user;
          this.user_profile.last_login = moment(this.user_profile.last_login).format('YYYY-MM-DD, hh:mm:ss');
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to retreive user\'s info';
      });
    },
    updateUserProfile() {
      var bodyFormData = {
        'first_name': this.user_profile.first_name,
        'last_name': this.user_profile.last_name,
        'company': this.user_profile.company,
        'phone': this.user_profile.phone,
      }

      this.$api.post('/api/auth/users/profile/update', bodyFormData).then(res => {
        if (res && res.status === 200) {
          // Snack notifications
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'User profile updated !';
        } else {
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = 'Unable to update user profile :/';
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to update user profile :/';
      });
    },
    updateUserPassword() {
      this.$api.post('/api/auth/users/profile/update-pw', this.user_profile_chpwd).then(res => {
        if (res && res.status === 200) {
          // Snack notifications
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'User profile password !';
        } else {
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = 'Unable to update user password :/';
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to update user password :/';
      });
    },
    renewUserPassword(){
      this.$api.get('/api/auth/users/profile/renew-pw').then(res => {
        if (res && res.status === 200 && res.data.status == "success") {
          this.new_password = 'New password: "'+res.data.password+'"';
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to retreive user\'s info';
      });
    },
    getSubscriptionsFromAPI(){
      this.subscriptions_loading = true;

      return new Promise(resolve => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage
        } = this.subscriptions_options;


        this.subscriptions_limit = itemsPerPage;
        let items = this.getSubscriptions(page, this.subscriptions_limit, sortBy, sortDesc);

        setTimeout(() => {
          resolve({
            items
          });
        }, 300);
        this.subscriptions_loading = false;
      });
    },
    getSubscriptions(page, itemsPerPage, sortBy, sortDesc){
      let sorted_by = '';
      if (sortBy.length > 0) {
        if (sortDesc[0] === true) {
          sorted_by = 'sorted_by=-' + sortBy;
        } else {
          sorted_by = 'sorted_by=' + sortBy;
        }
      }

      this.$api.get('/api/auth/subscriptions/list?limit='+itemsPerPage+'&page='+page+'&'+sorted_by).then(res => {
        if (res && res.status === 200) {
          this.subscriptions = res.data.results;
          this.subscriptions_total = res.data.count;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getInvoicesFromAPI(){
      this.invoices_loading = true;

      return new Promise(resolve => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage
        } = this.invoices_options;

        this.invoices_limit = itemsPerPage;
        let items = this.getInvoices(page, this.invoices_limit, sortBy, sortDesc);

        setTimeout(() => {
          resolve({
            items
          });
        }, 300);
        this.invoices_loading = false;
      });
    },
    getInvoices(page, itemsPerPage, sortBy, sortDesc){
      let sorted_by = '';
      if (sortBy.length > 0) {
        if (sortDesc[0] === true) {
          sorted_by = 'sorted_by=-' + sortBy;
        } else {
          sorted_by = 'sorted_by=' + sortBy;
        }
      }

      this.$api.get('/api/auth/subscriptions/invoices/list?limit='+itemsPerPage+'&page='+page+'&'+sorted_by).then(res => {
        if (res && res.status === 200) {
          this.invoices = res.data.results;
          this.invoices_total = res.data.count;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    cancelSubscription(sub_id){
      this.snack = true;
      this.snackColor = 'grey';
      this.snackText = 'Processing...';

      this.$api.get('/api/auth/subscriptions/cancel?subscription_id='+sub_id).then(res => {
        if (res && res.status === 200 && res.data.status == 'success') {
          this.getSubscriptions(1, 5, "", "sortDesc");
          // this.$refs.subscriptionstable.refresh();

          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Subscription successfully canceled. Remains active until the next paiement interval';
          this.subscriptions_options.page = 0;
          this.subscriptions_options.page = 1;
        }
      }).catch(e => {
        console.log(e)
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to cancel user\'s subscription';
      });
    },
    reactivateSubscription(sub_id){
      this.snack = true;
      this.snackColor = 'grey';
      this.snackText = 'Processing...';
      this.$api.get('/api/auth/subscriptions/reactivate?subscription_id='+sub_id).then(res => {
        if (res && res.status === 200 && res.data.status == 'success') {
          // this.getSubscriptions(1, 5, "", "sortDesc");
          this.getSubscriptionsFromAPI();
          // this.$refs.subscriptionstable.refresh();
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Subscription successfully reactivated';
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to reactivate user\'s subscription';
      });
    },
    showSubscriptionDetails(sub_id){
      this.selected_subscription = sub_id;
      this.dialog_subscription_details = true;
    },
  },
};
</script>

<style>
</style>
